export class Parameter {
    id : number;
    value: string;
    cacheName: string;
    prevId : number;
    active: string;
    paramKey:string;
    checked:boolean;
    remarks: string;
    prevValue:string;
    remarksYN:string;
    sortOrder: number;
}
